export const routes = [
  {
    name: 'breadcrumb.home',
    routeName: 'home',
    path: '/',
    children: [
      {
        name: 'breadcrumb.projects',
        routeName: 'projectDocument',
        path: '/projects',
        children: [
          {
            name: 'breadcrumb.setUpNewProject',
            routeName: 'setUpNewProject',
            path: '/projects/create'
          },
          {
            name: 'breadcrumb.project',
            routeName: 'projectName',
            path: '/projects/:projectId',
            children: [
              {
                name: 'breadcrumb.approvalPeriod',
                routeName: 'approvalPeriodName',
                path: '/projects/:projectId?tabId=2',
                children: [
                  {
                    name: 'breadcrumb.edit',
                    routeName: 'editProject',
                    path: '/projects/:projectId/edit'
                  }
                ]
              },
              {
                name: 'breadcrumb.projectMembers',
                routeName: 'projectMember',
                path: '/projects/:projectId?tabId=2',
                children: [
                  {
                    name: 'breadcrumb.edit',
                    routeName: 'editProjectMember',
                    path: '/projects/:projectId/members'
                  }
                ]
              },
              {
                name: 'breadcrumb.projectDashboard',
                routeName: 'projectDashboard',
                path: '/projects/:projectId/dashboards'
              },
              {
                name: 'breadcrumb.history',
                routeName: 'deletedDocument',
                path: '/projects/:projectId/history'
              },
              {
                name: 'breadcrumb.bulkPlanning',
                routeName: 'bulkPlanning',
                path: '/documents/bulk-planning?:projectId',
                children: [
                  {
                    name: 'breadcrumb.create',
                    routeName: 'createBulkPlanning',
                    path: '/documents/bulk-planning/:discipline?:projectId',
                    children: [
                      {
                        name: 'breadcrumb.relatedDocuments',
                        routeName: 'relatedDocuments',
                        path: '/documents/bulk-planning/:discipline/documents?:projectId'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'breadcrumb.newDocument',
                routeName: 'createDocument',
                path: '/documents/create'
              },
              {
                name: 'breadcrumb.projectDocument',
                routeName: 'documentName',
                path: '/documents/:documentId',
                children: [
                  {
                    name: 'breadcrumb.edit',
                    routeName: 'editDocument',
                    path: '/documents/:documentId/edit'
                  },
                  {
                    name: 'breadcrumb.share',
                    routeName: 'shareDocument',
                    path: '/documents/:documentId/share'
                  },
                  {
                    name: 'breadcrumb.newDocumentRevision',
                    routeName: 'createRevision',
                    path: '/document-revisions/create'
                  },
                  {
                    name: 'breadcrumb.projectDocumentRevision',
                    routeName: 'revisionName',
                    path: '/document-revisions/:revisionId',
                    children: [
                      {
                        name: 'breadcrumb.edit',
                        routeName: 'editRevision',
                        path: '/document-revisions/:revisionId/edit'
                      },
                      {
                        name: 'breadcrumb.createDocumentWorkflow',
                        routeName: 'createDocumentWorkflow',
                        path: '/document-workflows/create'
                      },
                      {
                        name: 'breadcrumb.flowName',
                        routeName: 'flowName',
                        path: '/document-revisions/:revisionId',
                        children: [
                          {
                            name: 'breadcrumb.edit',
                            routeName: 'editDocumentWorkflow',
                            path: '/document-workflows/:documentFlowId/edit'
                          },
                          {
                            name: 'breadcrumb.approval',
                            routeName: 'approval',
                            path: '/approvals/:documentFlowId'
                          }
                        ]
                      },
                      {
                        name: 'breadcrumb.projectDocumentFile',
                        routeName: 'documentFileName',
                        path: '/document-files/:documentFileId',
                        children: [
                          {
                            name: 'breadcrumb.download',
                            routeName: 'downloadFile',
                            path: '/document-version/:documentVersionId'
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                name: 'breadcrumb.newProjectWorkflow',
                routeName: 'createProjectWorkflow',
                path: '/project-workflows/create'
              },
              {
                name: 'breadcrumb.projectWorkflow',
                routeName: 'projectWorkflowName',
                path: '/projects/:projectId?tabId=1',
                children: [
                  {
                    name: 'breadcrumb.edit',
                    routeName: 'editProjectWorkflow',
                    path: '/project-workflows/:projectWorkflowId/edit'
                  }
                ]
              },
              {
                name: 'breadcrumb.flowName',
                routeName: 'flowName',
                path: '/projects/:projectId',
                children: [
                  {
                    name: 'breadcrumb.approval',
                    routeName: 'approvalOnly',
                    path: '/approvals/:documentFlowId'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        name: 'breadcrumb.standardWorkflow',
        routeName: 'standardWorkflow',
        path: '/standard-workflows'
      },
      {
        name: 'breadcrumb.documentMasterList',
        routeName: 'documentMasterList',
        path: '/document-master-list'
      },
      {
        name: 'breadcrumb.masterData',
        routeName: 'masterData',
        path: '/master-data',
        children: [
          {
            name: 'breadcrumb.masterDataName',
            routeName: 'masterDataName',
            path: '/master-data/:masterDataRef',
            children: [
              {
                name: 'breadcrumb.create',
                routeName: 'masterDataCreate',
                path: '/master-data/:masterDataRef/create'
              },
              {
                name: 'breadcrumb.masterDataSubName',
                routeName: 'masterDataSubName',
                path: '/master-data/:masterDataRef',
                children: [
                  {
                    name: 'breadcrumb.edit',
                    routeName: 'masterDataSubEdit',
                    path: '/master-data/:masterDataRef/:masterDataSubRef/edit'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        name: 'breadcrumb.myTask',
        routeName: 'myTask',
        path: '/my-tasks'
      },
      {
        name: 'breadcrumb.dashboard',
        routeName: 'dashboard',
        path: '/dashboards'
      },
      {
        name: 'breadcrumb.help',
        routeName: 'help',
        path: '/helps',
        children: [
          {
            name: 'breadcrumb.topic',
            routeName: 'helpTopic',
            path: '/helps/:helpTopicId',
            children: [
              {
                name: 'breadcrumb.topicName',
                routeName: 'topicName',
                path: '/helps/:helpTopicId/:topicNameId'
              }
            ]
          }
        ]
      }
    ]
  }
];
